<template>
    <!-- Новий дизайн — за макетом власника (design_handoff_about_page, 04.11): темний перший блок із фото піци, умовами доставки
         й смугою «Працюємо / Адреса / Телефон», «Про піцерію» з фото, «Як зробити замовлення / Оплата / Як отримати», «Акції»,
         категорії меню й банер застосунку. Тексти — дослівно з макета, з коротким тире «–» -->
    <div v-if="$v2" class="bp-about">
        <section class="bp-ab-hero" aria-labelledby="bp-ab-h1">
            <BpPageNav title="Про нас"/>
            <div class="bp-ab-hero__body">
                <div class="bp-ab-hero__main">
                    <h1 class="bp-ab-hero__h1" id="bp-ab-h1">Black Pizza</h1>
                    <p class="bp-ab-hero__tag">Мабуть, найкраща піцерія у світі ;)</p>
                    <p class="bp-ab-hero__lead">Працюємо на доставку й самовиніс.</p>
                    <div class="bp-ab-hero__terms">
                        <span class="bp-ab-hero__kicker">Умови доставки</span>
                        <p>Доставка безкоштовна. Для деяких районів є мінімальна сума замовлення.</p>
                    </div>
                    <router-link class="bp-ab-hero__cta" :to="{ name: 'delivery-map', params: $route.params }"><span class="bp-ab-hero__cta-ic" v-html="icons.map"></span>Мапа доставки<span class="bp-ab-hero__cta-arr" v-html="icons.chevronRight"></span></router-link>
                </div>
            </div>
            <ul class="bp-ab-hero__strip">
                <li class="bp-ab-hero__cell"><span class="bp-ab-hero__ic" v-html="icons.clock"></span><span class="bp-ab-hero__lbl">Працюємо</span><span class="bp-ab-hero__val">Щодня 11:00–22:00</span></li>
                <li class="bp-ab-hero__cell"><span class="bp-ab-hero__ic" v-html="icons.pin"></span><span class="bp-ab-hero__lbl">Адреса</span><span class="bp-ab-hero__val">{{ $store.state.address }}</span></li>
                <li class="bp-ab-hero__cell"><span class="bp-ab-hero__ic" v-html="icons.phone"></span><span class="bp-ab-hero__lbl">Телефон</span><a class="bp-ab-hero__val" :href="'tel:' + phoneDigits">{{ $store.state.phone }}</a></li>
            </ul>
        </section>

        <section class="bp-ab-intro" aria-labelledby="bp-ab-intro-h">
            <div class="bp-ab-intro__text">
                <h2 class="bp-ab-intro__h" id="bp-ab-intro-h">Black Pizza – піцерія в Луцьку з доставкою та самовиносом.</h2>
                <p>Ми готуємо піцу лише на доставку та самовиніс, тому повністю зосереджені на якості кожного замовлення. Візитівка Black Pizza – фірмова піца на темному тісті. Загалом у меню понад 40 видів піци.</p>
                <p>Доставка піци по Луцьку безкоштовна (для окремих районів діє мінімальна сума замовлення). Замовити піцу можна на сайті, у застосунку або телефоном, а забрати – самостійно в нашій піцерії.</p>
            </div>
            <div class="bp-ab-intro__media">
                <img src="@/assets/about/pizza-garden.webp" width="760" height="1046" alt="Дві піци Black Pizza у відкритих коробках" loading="lazy">
            </div>
        </section>

        <!-- Номери кроків (01–03) у макеті сховані — список лишається нумерованим лише для читачів екрана -->
        <ol class="bp-ab-steps">
            <li v-for="step in steps" :key="step.title" class="bp-ab-step">
                <h2 class="bp-ab-step__h">{{ step.title }}</h2>
                <p v-if="step.sub" class="bp-ab-step__sub">{{ step.sub }}</p>
                <ul class="bp-ab-tiles">
                    <li v-for="tile in step.tiles" :key="tile.title" class="bp-ab-tile">
                        <span class="bp-ab-tile__ic"><img :src="iconUrl(tile.icon)" alt="" width="56" height="56"></span>
                        <h3 class="bp-ab-tile__h">{{ tile.title }}</h3>
                        <a v-if="tile.phone" class="bp-ab-tile__t" :href="'tel:' + phoneDigits">{{ $store.state.phone }}</a>
                        <p v-else class="bp-ab-tile__t">{{ tile.text }}</p>
                    </li>
                </ul>
            </li>
        </ol>

        <section class="bp-ab-sec" aria-labelledby="bp-ab-promo-h">
            <h2 class="bp-ab-h2" id="bp-ab-promo-h">Акції</h2>
            <ul class="bp-ab-tiles bp-ab-tiles--promo">
                <li v-for="tile in promos" :key="tile.key" class="bp-ab-tile">
                    <span class="bp-ab-tile__ic"><img :src="iconUrl(tile.icon)" alt="" width="56" height="56"></span>
                    <h3 class="bp-ab-tile__h">{{ tile.title }}<span v-if="tile.nowrap" class="bp-ab-nowrap">{{ tile.nowrap }}</span></h3>
                    <p class="bp-ab-tile__t">{{ tile.text }}</p>
                </li>
            </ul>
        </section>

        <BpFaq variant="about" class="bp-ab-sec"/>

        <section v-if="categoryTiles.length" class="bp-ab-sec bp-ab-cats" aria-labelledby="bp-ab-cats-h">
            <h2 class="bp-ab-h2" id="bp-ab-cats-h">Переходьте в улюблену категорію та робіть замовлення</h2>
            <div class="bp-ab-cats__grid">
                <router-link v-for="cat in categoryTiles" :key="cat.code" class="bp-ab-cat" :class="'bp-ab-cat--' + cat.code"
                             :to="{ name: 'category.index', params: { ...$route.params, code: cat.code } }">
                    <img class="bp-ab-cat__img" :src="cat.photo" alt="" loading="lazy">
                    <span class="bp-ab-cat__name">{{ cat.name }}</span>
                    <span class="bp-ab-cat__go">Замовити</span>
                </router-link>
            </div>
        </section>

        <BpAboutApp/>
    </div>

    <div v-else style="margin-bottom: 140px">
        <div style="margin-bottom: 14px;text-align: left">
            <div class="page-title">
                Про нас
            </div>
        </div>

        <div>
            <img src="@/assets/about-us.jpg" style="
    width: 520px;
    margin-bottom: 25px;
">
        </div>

        <div style="
    text-align: left;
">
            <p>
                Black Pizza – нова ексклюзивна піцерія у Луцьку. Ми працюємо лише на доставку та самовиніс нашої піци,
                тому можемо забезпечувати надзвичайно високу якість продукції! Головною особливістю нашого закладу є
                фірмова піца на темному тісті. Загалом же у меню можна знайти аж 31 різних варіантів піци! Щодня ми
                забезпечуємо зручний та швидкий сервіс для наших клієнтів. Крім того, на відміну від інших піцерій
                Луцька, ми здійснюємо доставку піци абсолютно безкоштовно (для певних районів є мінімальна вартість
                замовлення).
            </p>
            <p>
                Наразі у Black Pizza діють декілька акцій:
                <ul>
                    <li>Знижка 7% на самовиніс з нашої піцерії.</li>
                    <li>При замовленні 2 або 3 піц напій (1 літр, на вибір) – безкоштовно!</li>
                    <li>Замовляйте 3 піци – 4-та (найдешевша у чеку) – лише за 50% вартості.</li>
                    <li>Також у комплекті з нашою піцою Ви завжди отримаєте фірмовий соус!</li>
                </ul>
            </p>
            <p>
                Щодня ми працюємо з 11:00 до 22:00.
            </p>
            <p>
                Завітайте до нас: {{ this.$store.state.address }}
            </p>
            <p>
                Тел. {{ this.$store.state.phone }}
            </p>
            <p>
                Увага! Для певних районів встановлена мінімальна сума замовлення для здійснення доставки – її можна
                дізнатись обравивши необхідний населений пункт та вулицю.
            </p>
        </div>
    </div>
</template>

<script>
import { ICONS } from '@/v2icons'
import BpPageNav from '@/components/BpPageNav.vue'
import BpAboutApp from '@/components/BpAboutApp.vue'
import BpFaq from '@/components/BpFaq.vue'

// Картки «Як зробити замовлення / Оплата / Як отримати» й «Акції» — тексти й іконки з макета (src/assets/about/icons,
// SVG 64×64 у колі 104 px). «Онлайн» — іконка online: саме її показує відрендерений макет (у README вона названа запасною)
const STEPS = [
    { title: 'Як зробити замовлення?', sub: 'Обирай зручний спосіб', tiles: [
        { icon: 'web', title: 'На сайті', text: 'Обери піцу й оформи замовлення в кошику' },
        { icon: 'phone', title: 'У застосунку', text: '5% кешбеку на перше замовлення і 3% – на наступні' },
        { icon: 'tel', title: 'Телефоном', phone: true }
    ] },
    { title: 'Оплата', sub: 'Спосіб обираєш у кошику', tiles: [
        { icon: 'cash', title: 'Готівкою', text: 'Під час отримання замовлення' },
        { icon: 'card', title: 'Карткою', text: 'Під час отримання замовлення' },
        { icon: 'pay', title: 'Онлайн', text: 'За допомогою LiqPay, Google Pay, Apple Pay' }
    ] },
    { title: 'Як отримати?', tiles: [
        { icon: 'courier', title: 'Доставка', text: 'Безкоштовно; для деяких районів – мінімальна сума замовлення' },
        { icon: 'pickup', title: 'Самовиніс', text: 'Забираєш сам – знижка 7%' },
        { icon: 'time', title: 'На зручний час', text: 'Час та дату доставки чи самовиносу обираєш у кошику' }
    ] }
];
// nowrap — кінець назви, який не можна розривати («4-ту піцу»)
const PROMOS = [
    { key: 'drink', icon: 'drink', title: 'Напій у подарунок', text: 'При замовленні 2 або 3 піц – напій на вибір у подарунок' },
    { key: 'half', icon: 'half', title: 'Знижка на ', nowrap: '4-ту піцу', text: 'Замов 4 піци – отримай знижку 50% на одну з них' },
    { key: 'pickup', icon: 'pickup7', title: '−7% на самовиніс замовлення', text: 'Знижка, коли забираєш замовлення сам' },
    { key: 'sauce', icon: 'sauce', title: 'Фірмовий часниковий соус', text: 'У комплекті з кожною піцою' }
];
// Фото категорій (прозорі, з макета) — за кодом категорії; категорії без фото на сторінці не показуємо
const CAT_PHOTOS = {
    pizza: require('@/assets/about/cat-pizza.webp'),
    beverages: require('@/assets/about/cat-beverages.webp'),
    // «Снеки» в базі — верхня категорія з кодом other (snacks — її підкатегорія)
    other: require('@/assets/about/cat-snacks.webp')
};

export default {
    components: { BpPageNav, BpAboutApp, BpFaq },

    data() {
        return {
            icons: ICONS,
            steps: STEPS,
            promos: PROMOS
        }
    },

    computed: {
        phoneDigits() {
            return (this.$store.state.phone || '').replace(/[^\d+]/g, '');
        },

        // Категорії, як у лівій панелі (увімкнені, верхнього рівня), — ті, для яких є фото з макета: піца, напої, снеки
        categoryTiles() {
            return this.$store.state.categories
                .filter(c => c.is_enabled == 1 && !c.parent_id && CAT_PHOTOS[c.code])
                .map(c => ({ code: c.code, name: c.name, photo: CAT_PHOTOS[c.code] }));
        }
    },

    methods: {
        iconUrl(name) {
            return require('@/assets/about/icons/' + name + '.svg');
        }
    }
}
</script>
